import React from 'react';
import { Link } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import CClogo from '../assets/CClogo.png';
const NotFound = (props) =>{
 return(
  <div >
    <div style={{ height: "100%", width: "100%", position: 'absolute', overflow: 'hidden' }}><div style={{
      display: 'flex',
      height: "100%",
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    }}>
      <Image style={{
        alignSelf: 'center',
        width: 150,
        height: 150,
      }}  src={CClogo} />
      <h3 style={{ fontFamily: "montserrat" }}>Page not found!</h3>
      <Link to="/">
        Go Home
    </Link>
    </div></div>
  </div>
);
    }
export default NotFound;